import { Injectable, inject } from '@angular/core';
import { Observable, filter, switchMap } from 'rxjs';
import { HttpService } from '@boels/helpers';
import { CultureFacade } from '../../cultures/facade/cultures.facade';

@Injectable({
  providedIn: 'any',
})
export class SiteContextGatewayService {
  private readonly httpService = inject(HttpService);
  private cultureFacade = inject(CultureFacade);

  getBaseSites(reqType?: string): Observable<any> {
    return this.cultureFacade.getActiveLanguage().pipe(
      filter((lang) => lang.length > 0),
      switchMap((lang) => {
        const url = `basesites?lang=${lang || 'en'}&fields=${reqType}`;
        return this.httpService.get(url);
      }),
    );
  }
}
